(function () {
  function ready(fn) {
    document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);
  }
  function waitFor(test, cb, interval = 40, timeout = 5000) {
    var t0 = Date.now();
    (function loop() {
      if (test()) return cb();
      if (Date.now() - t0 > timeout) return;
      setTimeout(loop, interval);
    })();
  }

  function parseOptsFromAttr($el) {
    var raw = $el.attr('data-slick');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      try {
        return JSON.parse(raw.replace(/\n|\r/g, '').replace(/\s{2,}/g, ' '));
      } catch (_) {
        return {};
      }
    }
  }

  function normalizeOptions(opts) {
    opts = Object.assign(
      {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        autoplay: false,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
      },
      opts || {}
    );
    if (
      opts.autoplay &&
      typeof opts.autoplaySpeed === 'number' &&
      opts.autoplaySpeed > 0 &&
      opts.autoplaySpeed < 1000
    ) {
      opts.autoplaySpeed *= 1000;
    }
    opts.infinite = !!opts.autoplay;
    if (opts.fade) {
      opts.slidesToShow = 1;
      opts.slidesToScroll = 1;
      if (!opts.cssEase) opts.cssEase = 'linear';
    }
    return opts;
  }

  function styleBase() {
    return 'position:absolute;bottom:0;left:0;height:4px;background-color:#000;z-index:10;';
  }
  function styleReset() {
    return 'width:0%!important;transition:none!important;' + styleBase();
  }
  function styleRunning(ms) {
    return 'width:100%!important;transition:width ' + ms + 'ms linear!important;' + styleBase();
  }

  function attachProgress($slider, opts) {
    var $container = $slider.closest('.slick-slideshow-wrapper');
    if (!$container.length) $container = $slider;
    var $wrap = $container.find('.slider-progress-bar-wrapper');
    var $bar = $container.find('.slider-progress-bar');
    if (!$bar.length || !opts.autoplay) return null;

    if ($wrap.length) {
      var pos = ($wrap.css('position') || '').toLowerCase();
      if (pos !== 'relative' && pos !== 'absolute' && pos !== 'fixed') $wrap.css('position', 'relative');
    }

    var dur = Math.floor((opts.autoplaySpeed || 5000) * 0.9);
    function setBarStyle(css) {
      $bar.attr('style', css);
    }
    function start() {
      setBarStyle(styleReset());
      void $bar[0].offsetWidth;
      void $bar[0].offsetHeight;
      setTimeout(function () {
        setBarStyle(styleRunning(dur));
      }, 150);
    }
    function reset() {
      setBarStyle(styleReset());
    }
    function restart() {
      reset();
      setTimeout(start, 50);
    }
    return { start: start, reset: reset, restart: restart };
  }

  function bindHandlers($el, opts, pb) {
    $el.off('.pb');
    if (pb) {
      $el.on('init.pb', function () {
        pb.restart();
      });
      $el.on('afterChange.pb', function () {
        pb.restart();
      });
      $el.on('beforeChange.pb', function () {
        pb.reset();
      });
      $el.on('mouseenter.pb', function () {
        $el.slick('slickPause');
        pb.reset();
      });
      $el.on('mouseleave.pb', function () {
        $el.slick('slickPlay');
        pb.start();
      });
      pb.restart();
    } else {
      $el.on('mouseenter.pb', function () {
        if (opts.autoplay) $el.slick('slickPause');
      });
      $el.on('mouseleave.pb', function () {
        if (opts.autoplay) $el.slick('slickPlay');
      });
    }
  }

  function initOne($el) {
    if ($el.hasClass('slick-initialized')) return;
    var opts = normalizeOptions(parseOptsFromAttr($el));
    $el.slick(opts);
    var pb = attachProgress($el, opts);
    bindHandlers($el, opts, pb);
  }

  function initSlides(root) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    $(root)
      .find('.slick-slideshow')
      .each(function () {
        initOne($(this));
      });
  }

  function destroySlides(root) {
    var $ = window.jQuery;
    if (!$) return;
    $(root)
      .find('.slick-slideshow')
      .each(function () {
        var $el = $(this);
        $el.off('.pb');
        if ($el.hasClass('slick-initialized')) $el.slick('unslick');
      });
  }

  ready(function () {
    waitFor(
      function () {
        return !!(window.jQuery && jQuery.fn && jQuery.fn.slick);
      },
      function () {
        initSlides(document);
      }
    );
  });
  document.addEventListener('shopify:section:load', function (e) {
    waitFor(
      function () {
        return !!(window.jQuery && jQuery.fn && jQuery.fn.slick);
      },
      function () {
        initSlides(e.target);
      }
    );
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroySlides(e.target);
  });
})();
